// extracted by mini-css-extract-plugin
module.exports = {"loader":"_1lfoft","button-loader":"FE-GWX","sm":"_2Nw2xP","md":"_1cAkR1","center":"_3KQiuZ","noPadding":"_1N4a62"};